import { api_fetch, api_fetch_throws } from "@/api"

// Mirrors server/src/category/rules.rs `CategoryRule`
export interface CategoryRule {
  id: string
  name: string
  description: string
  source: string
  retailer: string | null
  invoice_regex: string | null
  remark_regex: string | null
  dispute_email_to: string | null
  is_global: boolean
  disabled: boolean
  replaces_category_id: string | null
  matched_count: number
  manual_count: number
  example_invoice_numbers: string[]
  /** >1 means this entry represents several identical duplicate rows, collapsed. */
  duplicate_count: number
}

// Mirrors server/src/category/preview.rs `ProposedChange` (serde tag = "kind")
export type ProposedChange =
  | {
      kind: "edit_rule"
      id: string
      name?: string
      description?: string
      // empty string clears a pattern; omitted leaves it unchanged
      invoice_regex?: string
      remark_regex?: string
      retailer?: string
      dispute_email_to?: string
      disabled?: boolean
    }
  | {
      kind: "create_rule"
      name: string
      description: string
      source: string
      invoice_regex?: string
      remark_regex?: string
      retailer?: string
      dispute_email_to?: string
    }
  | { kind: "disable_rule"; id: string }
  | { kind: "rename_or_merge"; from_name: string; to_name: string }

export interface AffectedDeduction {
  id: string
  invoice_number: string
  invoice_date: string
  invoice_amount: number
  description: string | null
  current_name: string | null
  current_description: string | null
  new_name: string | null
  new_description: string | null
  manually_categorized: boolean
}

export interface PreviewResponse {
  total_affected: number
  sample: AffectedDeduction[]
  warnings: string[]
}

export interface ApplyResponse {
  updated_deductions: number
  created_category_ids: string[]
  repointed_rules: number
}

export function fetch_category_rules() {
  return api_fetch_throws<CategoryRule[]>("/categories/rules", { use_cache: false })
}

export function preview_change(change: ProposedChange) {
  return api_fetch<PreviewResponse>("/categories/rules/preview", { method: "POST", body: change })
}

export function apply_change(change: ProposedChange) {
  return api_fetch<ApplyResponse>("/categories/rules/apply", { method: "POST", body: change })
}

export function delete_category_rule(id: string) {
  return api_fetch("/categories/rules/" + id, { method: "DELETE" })
}
